import { get, post } from "utilities/network";

export interface CashbackSettings {
  enabled: boolean;
  rate: number | string;
  eligibleBillTypes: string[];
  eligibleNetworks: string[];
  startsAt: string;
  endsAt: string;
  totalBudget: number | string;
  minimumPurchase: number | string;
  roundingRule: string;
  perUserCap: number | string | null;
  fraudBudgetShare: number | string | null;
  fraudPurchaseCount: number | null;
  fraudWindowSeconds: number | null;
}

export interface CashbackCampaign extends CashbackSettings {
  id: number;
  totalCredited: number | string;
  exhaustedAt: string | null;
}

export interface CashbackDashboard {
  totalCashbackPaid: number;
  budgetRemaining: number;
  usersEarned: number;
  qualifyingPurchases: number;
  cashbackPerUser: number;
}

export interface CashbackEarner {
  userId: number;
  totalCashback: number | string;
}

export const cashbackKeys = {
  settings: ["billCashback", "settings"] as const,
  dashboard: ["billCashback", "dashboard"] as const,
  earners: ["billCashback", "topEarners"] as const,
};

const endpoint = "admin/bill-cashback";

export const fetchCashbackSettings =
  async (): Promise<CashbackCampaign | null> =>
    (await get(`${endpoint}/settings`)).campaign;

export const fetchCashbackDashboard =
  async (): Promise<CashbackDashboard | null> =>
    (await get(`${endpoint}/dashboard`)).dashboard;

export const fetchCashbackEarners = async (): Promise<CashbackEarner[]> =>
  (await get(`${endpoint}/top-earners?limit=20`)).earners;

export const saveCashbackSettings = async (
  settings: CashbackSettings,
): Promise<CashbackCampaign> =>
  (await post(`${endpoint}/settings`, settings)).data.campaign;

export const excludeCashbackUser = async (userId: number): Promise<void> => {
  await post(`${endpoint}/exclusions`, { userId });
};

export const fetchCashbackReport = async (): Promise<Record<
  string,
  unknown
> | null> => (await get(`${endpoint}/report`)).report;
